/**
 * Photos from Pickcel Booth G37 at InfoComm India 2026 (JWCC, Mumbai).
 */

import { env } from "@/lib/environment";

export interface InfoCommPhoto {
  src: string;
  width: number;
  height: number;
  alt: string;
}

const ALT = "Pickcel booth at InfoComm India 2026, Jio World Convention Centre, Mumbai";
const CDN = `${env.NEXT_PUBLIC_CDN_URL}/images/events/infocomm/photo`;

export const infocommPhotos: readonly InfoCommPhoto[] = [
  { src: `${CDN}/photo-01.aqdk9rWDRaav.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-02.aIRVL1zC-Zbu.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-03.hEH6NXXqcFWo.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-04.sp7zsShDpjKT.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-05.ra7kEiB46T8_.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-06.LZKESthCiC2s.jpg`, width: 1078, height: 1920, alt: ALT },
  { src: `${CDN}/photo-07.D3ZjleyzjqYb.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-08.sPvNvZrZdccf.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-09.mat1u6Jelokq.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-10.Fh-_BKSqQhu_.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-11.82LalpusRPMo.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-12.Upbpm01Qxnds.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-13.VjiPr-DM_L04.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-14.FeuhNS9sDNfQ.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-15.TFC6s08sejSj.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-16.6lqmwBtLtrBP.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-17.xPMEBtOB0YBe.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-18.JOHolo9zwjQe.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-19.hN5LFXLRGNHT.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-20.CRD0JbmHzARs.jpg`, width: 1078, height: 1920, alt: ALT },
  { src: `${CDN}/photo-21.KrtsxrLtkiqh.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-22.0SGMnMdvogHG.jpg`, width: 1078, height: 1920, alt: ALT },
  { src: `${CDN}/photo-23.n0G9FvFRjOJ1.jpg`, width: 1078, height: 1920, alt: ALT },
  { src: `${CDN}/photo-24.6YXP1Ld8SLdx.jpg`, width: 1078, height: 1920, alt: ALT },
  { src: `${CDN}/photo-25.IhFrIfmOb0nM.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-26.SarM_5pVp5q7.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-27.VLE7eWIeWEVZ.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-28.9dLFlktECtg6.jpg`, width: 1078, height: 1920, alt: ALT },
  { src: `${CDN}/photo-29.KswN26mba0Cm.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-30.EBXiq1DKtTxW.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/photo-31.AaeiVx8D_tb2.jpg`, width: 1920, height: 1078, alt: ALT },
  { src: `${CDN}/_DSC8640.SC1I_OSTfpO_.JPG`, width: 7008, height: 4672, alt: ALT },
  { src: `${CDN}/_DSC8711.eCCOB3qeCrNA.JPG`, width: 7008, height: 4672, alt: ALT },
  { src: `${CDN}/5K6A6020.FQ9vgg7cR8zx.JPG`, width: 6000, height: 3368, alt: ALT },
  { src: `${CDN}/5K6A6273.s8RWXTS_MLyA.JPG`, width: 6000, height: 3368, alt: ALT },
  { src: `${CDN}/5K6A6276.7L84tj8pC7xa.JPG`, width: 6000, height: 3368, alt: ALT },
];
